"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDatevOnlineConnected = exports.DatevOnlineConnectionStatusEnum = void 0;
var DatevOnlineConnectionStatusEnum;
(function (DatevOnlineConnectionStatusEnum) {
    DatevOnlineConnectionStatusEnum[DatevOnlineConnectionStatusEnum["DISCONNECTED"] = 0] = "DISCONNECTED";
    DatevOnlineConnectionStatusEnum[DatevOnlineConnectionStatusEnum["PENDING"] = 1] = "PENDING";
    DatevOnlineConnectionStatusEnum[DatevOnlineConnectionStatusEnum["CONNECTED"] = 2] = "CONNECTED";
})(DatevOnlineConnectionStatusEnum || (exports.DatevOnlineConnectionStatusEnum = DatevOnlineConnectionStatusEnum = {}));
const isDatevOnlineConnected = (datevOnlineConnectionStatus) => datevOnlineConnectionStatus === DatevOnlineConnectionStatusEnum.CONNECTED;
exports.isDatevOnlineConnected = isDatevOnlineConnected;
